import React from 'react';
import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar, Tooltip } from 'recharts';

const CustomBarChart = ({ data = [], title = '', subtitle = 'User Statistics', userCount = 0 }) => {
  const hasMeaningfulData = data && data.length > 0 && data.some(item => item.value > 0);

  const chartData = hasMeaningfulData
    ? data
    : [
        { month: 'Jan', value: null },
        { month: 'Feb', value: null },
        { month: 'Mar', value: null },
        { month: 'Apr', value: null },
        { month: 'May', value: null },
        { month: 'Jun', value: null },
        { month: 'Jul', value: null },
        { month: 'Aug', value: null },
        { month: 'Sep', value: null },
        { month: 'Oct', value: null },
        { month: 'Nov', value: null },
        { month: 'Dec', value: null },
      ];

  const RoundedBar = props => {
    const { x, y, width, height, fill, value } = props;
    const radius = 8;

    if (value === null || value === 0 || !hasMeaningfulData) {
      return null;
    }

    return (
      <path
        d={`
          M${x},${y + radius}
          Q${x},${y} ${x + radius},${y}
          L${x + width - radius},${y}
          Q${x + width},${y} ${x + width},${y + radius}
          L${x + width},${y + height}
          L${x},${y + height}
          Z
        `}
        fill={fill}
      />
    );
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const value = payload[0].value;
      const isNullValue = value === null;

      return (
        <div className="p-2 bg-white border border-gray-200 rounded shadow-sm">
          <p className="text-sm font-medium">
            {`${payload[0].payload.month}: ${
              hasMeaningfulData && !isNullValue ? value : 'No data'
            }`}
          </p>
        </div>
      );
    }
    return null;
  };

  const FallbackOverlay = () => (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-80">
      <div className="p-4 text-center">
        <div className="mb-2 text-gray-400">
          <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
        </div>
        <p className="mb-1 text-sm text-gray-600">No data available</p>
        <p className="text-sm text-gray-500">Chart will update when data is available</p>
      </div>
    </div>
  );

  return (
    <div className="relative flex flex-col w-full h-full">
      <div className="pb-2 pl-4 text-base font-semibold">{title}</div>
      <div className="flex justify-center pt-2 pb-6 text-sm font-medium">{subtitle}</div>
      <div className="relative w-full h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{ top: 5, right: 30, left: 20, bottom: 30 }}
            barSize={16}>
            <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fontSize: 12 }} />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12 }}
              domain={[0, hasMeaningfulData ? userCount || 'auto' : 100]}
            />
            <Tooltip
              content={<CustomTooltip />}
              cursor={hasMeaningfulData ? { fill: 'transparent' } : false}
            />
            <Bar
              dataKey="value"
              fill="#2b1f49"
              background={{ fill: '#F2F7FF' }}
              shape={<RoundedBar />}
            />
          </BarChart>
        </ResponsiveContainer>

        {!hasMeaningfulData && <FallbackOverlay />}
      </div>
    </div>
  );
};

export default CustomBarChart;
